export const getHotelBookingStatus = (status) => {
  switch (status) {
    case 1:
      return <p style={{ color: "#FFA500" }}>FAILED</p>;

    case 2:
      return <p style={{ color: "#008000" }}>CONFIRMED</p>;

    case 3:
      return <p style={{ color: "#FF0000" }}>CANCELLED</p>;

    case 4:
      return <p style={{ color: "#FF0000" }}>PENDING</p>;

    case 5:
      return <p style={{ color: "#f9e218" }}>REJECTED</p>;

    case 6:
      return <p style={{ color: "#FF0000" }}>HOLD</p>;

    case 7:
      return <p style={{ color: "#FF0000" }}>CANCELLATION REQUESTED</p>;

    case 8:
      return <p style={{ color: "#FF0000" }}>CANCELLATION PENDING</p>;

    case 9:
      return <p style={{ color: "#FF0000" }}>CANCELLATION IN PROGRESS</p>;

    default:
      return "";
  }
};

export const getBusBookingStatus = (status) => {
  switch (status) {
    case 2:
      return <p style={{ color: "#FFA500" }}>BLOCKED</p>;

    case 3:
      return <p style={{ color: "#008000" }}>CONFIRMED</p>;

    case 5:
      return <p style={{ color: "#FF0000" }}>CANCELLED</p>;

    case 7:
      return <p style={{ color: "#008000" }}>PARTIALLY CANCELLED</p>;

    default:
      return "";
  }
};

export const getActivitiesBookingStatus = (status) => {
  switch (status) {
    case 0:
      return <p style={{ color: "#FF0000" }}>CANCELLED</p>;

    case 1:
      return <p style={{ color: "#FF0000" }}>ALREADY CANCELLED</p>;

    case 2:
      return <p style={{ color: "#FFA500" }}>BLOCKED</p>;

    case 3:
      return <p style={{ color: "#008000" }}>CONFIRMED</p>;

    default:
      return "";
  }
};

export const getFlightTicketStatus = (status) => {
  switch (status) {
    case 1:
      return <p style={{ color: "#f9e218" }}>CREATED</p>;

    case 2:
      return <p style={{ color: "#FFA500" }}>BLOCKED</p>;

    case 3:
      return <p style={{ color: "#008000" }}>CONFIRMED</p>;

    case 4:
      return <p style={{ color: "#FF0000" }}>CANCELLED</p>;

    case 5:
      return <p style={{ color: "#008000" }}>PARTIALLY CANCELLED</p>;

    case 6:
      return <p style={{ color: "#FF0000" }}>CANCELLATION REQUESTED</p>;

      case 10:
        return <p style={{ color: "#FF0000" }}>HOLD</p>;

    default:
      return "";
  }
};

/** Hide flight ticket sidebar on Blocked / Cancelled — keep Hold(10) and Confirmed(3). */
export function isFlightTicketSidebarHidden(ticketData = {}) {
  if (String(ticketData?.BookingStatus ?? "").toUpperCase() === "CANCELLED") {
    return true;
  }
  const primary = Number(ticketData?.oneWaySegment?.[0]?.bookingStatus ?? 0);
  return primary === 2 || primary === 4;
}

export function shouldShowFlightTicketSidebar(ticketData = {}) {
  return !isFlightTicketSidebarHidden(ticketData);
}

/** Show Payment Status on flight ticket only when Confirmed (3 → Paid). */
export function shouldShowFlightPaymentStatus(bookingStatus) {
  return Number(bookingStatus) === 3;
}

export function getFlightPaymentStatusText(bookingStatus) {
  return Number(bookingStatus) === 3 ? "Paid" : "Due";
}

/** Flight sidebar download collapse title by booking status. */
export function getFlightDownloadSidebarHeader(ticketData = {}) {
  const status = Number(ticketData?.oneWaySegment?.[0]?.bookingStatus ?? 0);
  if (status === 10) {
    return "Download Flight Ticket";
  }
  if (status === 3) {
    return "Download Flight Ticket/Invoice";
  }
  return "Download Flight Ticket";
}

/** Show flight sidebar action buttons (cancel, release, markup, confirm) only on Hold(10) or Confirmed(3). */
export function shouldShowFlightSidebarActions(ticketData = {}) {
  const statuses = [
    ticketData?.oneWaySegment?.[0]?.bookingStatus,
    ticketData?.returnSegment?.[0]?.bookingStatus,
  ]
    .filter((status) => status != null && status !== "")
    .map((status) => Number(status));

  if (!statuses.length) {
    return false;
  }

  return statuses.some((status) => status === 10 || status === 3);
}

//  HotelBookingStatus
//     FAILED = 1,
//     CONFIRMED = 2,
//     CANCELLED = 3,
//     PENDING = 4,
//     REJECTED = 5,
//     HOLD = 6,
//     CancellationRequest = 7,
//     CancellationPending = 8,
//     CancellationInProgress = 9

//  BusBookingStatus
//     BLOCKED = 2,
//     CONFIRMED = 3
//     CANCELLED = 5,
//     PARTIALLYCANCELLED = 7,

// ActivitiesBookingStatus
//     CANCELLED = 0,
//     ALREADYCANCELLED = 1,
//     BLOCKED = 2,
//     CONFIRMED = 3

// flightTicketStatus
//     CREATED = 1,
//     BLOCKED = 2,
//     CONFIRMED = 3,
//     CANCELLED = 4,
//     PARTIALLY_CANCELLED = 5,
//     CANCELLATIONREQUESTED = 6
